import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-5" }
const _hoisted_2 = { class: "col-span-12 flex flex-col gap-5" }
const _hoisted_3 = { class: "flex justify-between flex-col md:flex-row items-center gap-3" }
const _hoisted_4 = { class: "capitalize" }
const _hoisted_5 = {
  key: 0,
  id: "classroom-input",
  class: "font-bold p-input-icon-right"
}
const _hoisted_6 = {
  key: 0,
  class: "pi pi-search"
}
const _hoisted_7 = { class: "flex items-center justify-between mb-4" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex justify-center gap-5 items-center"
}
const _hoisted_12 = {
  class: /*#__PURE__*/_normalizeClass(['flex flex-col gap-5 w-/12'])
}
const _hoisted_13 = { class: "flex items-center gap-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = {
  key: 0,
  class: "col-span-12 md:col-span-6"
}
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "grid grid-cols-12 items-center"
}
const _hoisted_19 = { class: "col-span-8" }
const _hoisted_20 = { class: "col-span-4 flex flex-col gap-5" }
const _hoisted_21 = { class: "flex items-center gap-1" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ApexChart = _resolveComponent("ApexChart")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.data.course.name?.concat(
              _ctx.classroomSelected?.name ? ` - ${_ctx.classroomSelected?.name}` : ""
            )), 1),
        (_ctx.hasClassroom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_AutoComplete, {
                id: "classroom",
                modelValue: _ctx.classroomSelected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.classroomSelected) = $event)),
                suggestions: _ctx.classrooms,
                forceSelection: true,
                onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getClasses($event))),
                onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setClassroomId(_ctx.classroomSelected?.id))),
                placeholder: _ctx.$t('homeStudent.filters.classroom.placeholder'),
                optionLabel: "name",
                class: _normalizeClass(`w-96`)
              }, null, 8, ["modelValue", "suggestions", "placeholder"]),
              (!_ctx.classroomSelected?.id)
                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "pi pi-times cursor-pointer",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {
              _ctx.setClassroomId(undefined);
              _ctx.classroomSelected = '';
            }, ["prevent"]))
                  }))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("stats.course.sidebar.general")), 1),
        _createVNode(_component_Button, {
          label: _ctx.$t('labels.generic', { pt: 'Baixar', en: 'Download' }),
          icon: "pi pi-download",
          class: "p-button-sm btn-primary h-9",
          loading: _ctx.btnLoading,
          onClick: _ctx.downloadCsv
        }, null, 8, ["label", "loading", "onClick"])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.cards, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: _normalizeClass(['col-span-12', _ctx.isAdaptive ? 'md:col-span-6' : ''])
      }, [
        item
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              data: item
            }, null, 8, ["data"]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass(['col-span-12', _ctx.isAdaptive ? 'md:col-span-6' : 'md:col-span-12'])
    }, [
      _createVNode(_component_Card, {
        hasBorder: false,
        isEmpty: true
      }, {
        content: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t("labels.generic", { pt: "Alunos", en: "Students" })), 1),
                (_ctx.students?.series?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.isAdaptive ? 'w-8/12' : 'w-5/12'])
                      }, [
                        _createVNode(_component_ApexChart, {
                          type: "donut",
                          options: _ctx.students.options,
                          series: _ctx.students.series
                        }, null, 8, ["options", "series"])
                      ], 2),
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.students.legends, (item, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("h5", null, _toDisplayString(item.title), 1),
                              (item.tooltip)
                                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_14, [
                                    _createVNode(_component_v_icon, {
                                      name: "hi-information-circle",
                                      scale: 0.8
                                    }, null, 8, ["scale"])
                                  ])), [
                                    [_directive_tooltip, `${item.tooltip}`]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("p", {
                                class: _normalizeClass(`${item.color} h-2 w-2 rounded-full`)
                              }, null, 2),
                              _createElementVNode("h3", null, _toDisplayString(item.number), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_EmptyData, {
                  data: _ctx.students?.series?.length === 0,
                  title: _ctx.emptyState.title,
                  label: _ctx.emptyState.description,
                  image: _ctx.emptyState.image,
                  imgSize: "h-40"
                }, null, 8, ["data", "title", "label", "image"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    (_ctx.isAdaptive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_Card, {
            hasBorder: false,
            isEmpty: true
          }, {
            content: _withCtx(() => [
              _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Alunos que desativaram a detecção",
                en: "Students who turned detection off",
              })), 1),
              (_ctx.students?.series?.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_ApexChart, {
                        key: "attention-chart",
                        type: "donut",
                        options: _ctx.attention.options,
                        series: _ctx.attention.series
                      }, null, 8, ["options", "series"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attention.legends, (item, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("h5", null, _toDisplayString(item.title), 1),
                            (item.tooltip)
                              ? _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_22, [
                                  _createVNode(_component_v_icon, {
                                    name: "hi-information-circle",
                                    scale: 0.8
                                  }, null, 8, ["scale"])
                                ])), [
                                  [
                                    _directive_tooltip,
                                    `${item.tooltip}`,
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("p", {
                              class: _normalizeClass(`${item.color} h-2 w-2 rounded-full`)
                            }, null, 2),
                            _createElementVNode("h3", null, _toDisplayString(item.number), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_EmptyData, {
                data: _ctx.students?.series?.length === 0,
                title: _ctx.emptyState.title,
                label: _ctx.emptyState.description,
                image: _ctx.emptyState.image,
                imgSize: "h-40 my-10"
              }, null, 8, ["data", "title", "label", "image"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}